import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';
import type { Role } from '@shared/types';

interface ProtectedRouteProps {
  children: ReactNode;
  /** 需要的角色：admin 或 agent */
  requireRole?: Role;
}

/**
 * 路由守卫组件
 * 1. 检查是否有token → 无则跳转登录页
 * 2. 检查角色是否匹配 → 不匹配跳转对应首页
 * 3. 通过则渲染子组件
 */
export function ProtectedRoute({ children, requireRole }: ProtectedRouteProps) {
  const token = useAuthStore((state) => state.token);
  const user = useAuthStore((state) => state.user);

  // 未认证 → 跳转登录
  if (!token) {
    const isMobile = window.location.pathname.startsWith('/m/');
    return <Navigate to={isMobile ? '/m/login' : '/login'} replace />;
  }

  // 需要角色检查
  if (requireRole && user) {
    if (user.role !== requireRole) {
      // 角色不匹配 → 跳转对应首页
      const targetPath = user.role === 'admin' ? '/admin/dashboard' : '/m/home';
      return <Navigate to={targetPath} replace />;
    }
  }

  return <>{children}</>;
}
